import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import Button from "../../../../components/form/Button";
import { styles } from "../../index";
import { isInternal } from "../../CroUtils";

const ShowOverviewHistoryButton = ({ auth, segment, dispatch }) => {
  if (!auth || !segment || !isInternal(auth)) return null;
  return (
    <div style={{ marginBottom: 12 }}>
      <Button
        type="button"
        style={styles.buttons}
        label="Zobrazit historii"
        onClick={() => dispatch(push(`${auth.startUrl}/${segment}/historie`))}
      />
    </div>
  );
};

export default connect()(ShowOverviewHistoryButton);
